import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { AutoSave } from './AutoSave';
import { TileActionText } from './TileActionText';
import { SaveAndCloseButton } from './TileActionButtons';

import { LeftButton, RightButton } from './StyledComponents';

export const EditFormMenu = ({
  goToPreview,
  campaignContainer,
  postId,
  tileStatus,
  publishDate,
  onClose,
  uuid,
  autoSaved,
}) => {
  const { t } = useTranslation('tileForm');

  return (
    <>
      <LeftButton mode="outline" variant="black" onClick={onClose}>
        <SaveAndCloseButton />
      </LeftButton>
      <AutoSave autoSaved={autoSaved} />
      <TileActionText
        publishDate={publishDate}
        tileStatus={tileStatus}
        postId={postId}
        campaignContainer={campaignContainer}
        uuid={uuid}
      />
      <RightButton
        uuid={uuid}
        mode="outline"
        onClick={goToPreview}
        variant="black"
      >
        <i className="fa-light fa-eye fa-lg"></i>
        {t('tileActionMenu.preview')}
      </RightButton>
    </>
  );
};

EditFormMenu.propTypes = {
  goToPreview: PropTypes.func,
  campaignContainer: PropTypes.string,
  postId: PropTypes.number,
  tileStatus: PropTypes.string,
  publishDate: PropTypes.string,
  onClose: PropTypes.func,
  uuid: PropTypes.string,
  autoSaved: PropTypes.shape({
    status: PropTypes.string,
    time: PropTypes.string,
  }),
};
